/* ============================================
   UJEVARA — Theme JavaScript
   ============================================ */

(function() {
  'use strict';

  // === CURSOR GLOW ===
  const glow = document.getElementById('ujevara-glow');
  if (glow) {
    document.addEventListener('mousemove', function(e) {
      glow.style.left = e.clientX + 'px';
      glow.style.top = e.clientY + 'px';
    });
  }

  // === NAVBAR SCROLL ===
  const header = document.querySelector('.uj-header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 50);
    });
  }

  // === MOBILE MENU ===
  const burger = document.getElementById('uj-burger');
  const mobileMenu = document.getElementById('uj-mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', function() {
      mobileMenu.classList.toggle('open');
      burger.textContent = mobileMenu.classList.contains('open') ? '✕' : '☰';
    });
    mobileMenu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() {
        mobileMenu.classList.remove('open');
        burger.textContent = '☰';
      });
    });
  }

  // === SCROLL REVEAL (IntersectionObserver) ===
  function initReveals() {
    var reveals = document.querySelectorAll('.rv');
    if (!reveals.length) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vis');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    reveals.forEach(function(el) { observer.observe(el); });
  }
  initReveals();
  // Re-init on Shopify section load
  document.addEventListener('shopify:section:load', initReveals);

  // === PARTICLES ===
  function initParticles() {
    var container = document.getElementById('uj-particles');
    if (!container || container.children.length > 0) return;
    for (var i = 0; i < 35; i++) {
      var p = document.createElement('div');
      p.className = 'uj-particle';
      p.style.left = Math.random() * 100 + '%';
      p.style.animationDuration = (4 + Math.random() * 6) + 's';
      p.style.animationDelay = Math.random() * 5 + 's';
      var size = (1 + Math.random() * 2) + 'px';
      p.style.width = size;
      p.style.height = size;
      if (Math.random() > 0.7) p.style.background = '#26a69a';
      container.appendChild(p);
    }
  }
  initParticles();
  document.addEventListener('shopify:section:load', initParticles);

  // === MARQUEE ===
  function initMarquee() {
    var mq = document.getElementById('uj-marquee-inner');
    if (!mq || mq.children.length > 0) return;
    var words = ['WATERFALLS','HOODIES','OVERSIZED','NATURE','ANIME','STREETWEAR',
                 'UJEVARA','FORCES','PREMIUM','滝','嵐','CHAOS','JOGGERS'];
    var all = words.concat(words, words, words);
    all.forEach(function(word) {
      var span = document.createElement('span');
      if (word.length <= 2) {
        span.innerHTML = '<em>' + word + '</em>';
      } else {
        span.textContent = word;
      }
      mq.appendChild(span);
    });
  }
  initMarquee();
  document.addEventListener('shopify:section:load', initMarquee);

  // === ACCORDION (FAQ / Return policy) ===
  document.addEventListener('click', function(e) {
    var accHead = e.target.closest('.uj-acc-head');
    if (!accHead) return;
    var item = accHead.closest('.uj-acc-item');
    var accordion = item.parentElement;
    var wasOpen = item.classList.contains('open');

    // Close all
    accordion.querySelectorAll('.uj-acc-item').forEach(function(el) {
      el.classList.remove('open');
      el.querySelector('.uj-acc-body').style.maxHeight = '0';
    });

    // Open clicked (if it was closed)
    if (!wasOpen) {
      item.classList.add('open');
      var body = item.querySelector('.uj-acc-body');
      body.style.maxHeight = body.scrollHeight + 'px';
    }
  });

  // === SIZE SELECTOR ===
  document.addEventListener('click', function(e) {
    var sizeBtn = e.target.closest('.uj-size-btn');
    if (!sizeBtn) return;
    sizeBtn.parentElement.querySelectorAll('.uj-size-btn').forEach(function(b) {
      b.classList.remove('active');
    });
    sizeBtn.classList.add('active');
    // Update hidden input for Shopify variant
    var sizeInput = document.getElementById('uj-selected-size');
    if (sizeInput) sizeInput.value = sizeBtn.textContent.trim();
  });

  // === QUANTITY CONTROLS ===
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var change = parseInt(btn.getAttribute('data-qty-change'));
    var display = btn.parentElement.querySelector('.qty-val');
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    var current = parseInt(display.textContent) || 1;
    var newVal = Math.max(1, current + change);
    display.textContent = newVal;
    if (input) input.value = newVal;
  });

  // === CART DRAWER ===
  window.ujOpenCart = function() {
    document.getElementById('uj-cart-overlay').classList.add('open');
    document.getElementById('uj-cart-drawer').classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.ujCloseCart = function() {
    document.getElementById('uj-cart-overlay').classList.remove('open');
    document.getElementById('uj-cart-drawer').classList.remove('open');
    document.body.style.overflow = '';
  };

  var cartOverlay = document.getElementById('uj-cart-overlay');
  if (cartOverlay) {
    cartOverlay.addEventListener('click', window.ujCloseCart);
  }

  // === TOAST NOTIFICATION ===
  window.ujToast = function(msg) {
    var toast = document.getElementById('uj-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 2500);
  };

  // === AJAX ADD TO CART (Shopify) ===
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.uj-product-form');
    if (!form) return;
    e.preventDefault();

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(res) { return res.json(); })
    .then(function(item) {
      ujToast(item.title + ' toegevoegd aan je cart!');
      updateCartDrawer();
      ujOpenCart();
    })
    .catch(function(err) {
      console.error('Cart error:', err);
    });
  });

  // Quick-add buttons on product cards
  document.addEventListener('click', function(e) {
    var quickAdd = e.target.closest('.uj-quick-add[data-variant-id]');
    if (!quickAdd) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = quickAdd.getAttribute('data-variant-id');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function(res) { return res.json(); })
    .then(function(item) {
      ujToast(item.title + ' toegevoegd!');
      updateCartDrawer();
      ujOpenCart();
    })
    .catch(function(err) { console.error(err); });
  });

  // Remove from cart
  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('.uj-cart-item-remove');
    if (!removeBtn) return;
    var key = removeBtn.getAttribute('data-key');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(res) { return res.json(); })
    .then(function() { updateCartDrawer(); });
  });

  // Update cart drawer contents via AJAX
  function updateCartDrawer() {
    fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      // Update count
      document.querySelectorAll('.uj-cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
      });

      // Update total
      var totalEl = document.getElementById('uj-cart-total-val');
      if (totalEl) {
        totalEl.textContent = '€' + (cart.total_price / 100).toFixed(2).replace('.', ',');
      }

      // Update items
      var body = document.getElementById('uj-cart-body');
      if (!body) return;

      if (cart.items.length === 0) {
        body.innerHTML = '<div class="uj-cart-empty"><p>Je winkelwagen is leeg</p>' +
          '<a href="/collections/all" class="btn-outline">Shop Now</a></div>';
        return;
      }

      var html = '';
      cart.items.forEach(function(item) {
        var img = item.featured_image && item.featured_image.url
          ? '<img src="' + item.featured_image.url + '" alt="' + item.title + '">'
          : '';
        html += '<div class="uj-cart-item">' +
          '<div class="uj-cart-item-img">' + img + '</div>' +
          '<div class="uj-cart-item-info">' +
            '<div class="uj-cart-item-name">' + item.product_title + '</div>' +
            '<div class="uj-cart-item-variant">' + item.variant_title + ' · Qty: ' + item.quantity + '</div>' +
            '<div class="uj-cart-item-price">€' + (item.final_line_price / 100).toFixed(2).replace('.', ',') + '</div>' +
            '<button class="uj-cart-item-remove" data-key="' + item.key + '">Verwijderen</button>' +
          '</div></div>';
      });
      body.innerHTML = html;
    });
  }

  // Initial cart load
  updateCartDrawer();

  // === PRODUCT IMAGE THUMBS ===
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('.uj-pd-thumb');
    if (!thumb) return;
    var imgSrc = thumb.getAttribute('data-img-src');
    var mainImg = document.querySelector('.uj-pd-main-img img');
    if (mainImg && imgSrc) {
      mainImg.src = imgSrc;
    }
    thumb.parentElement.querySelectorAll('.uj-pd-thumb').forEach(function(t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
  });

})();
